/**
 * Placeholder content panel — temporary stand-in for screens not yet built
 * pixel-exact (Phase 7). Keeps the shell navigable in the meantime.
 */
import React from 'react';
import { Text, View } from 'react-native';
import { useTheme } from '../context/themeContext';
import { useResponsive, MAX_CONTENT_WIDTH } from '../utils/responsive';

const Placeholder: React.FC<{ title: string }> = ({ title }) => {
  const { theme } = useTheme();
  const { colors, font } = theme;
  const { isWide } = useResponsive();
  return (
    <View style={{ maxWidth: MAX_CONTENT_WIDTH, width: '100%', alignSelf: 'center', padding: isWide ? 28 : 16 }}>
      <View style={{ backgroundColor: colors.card, borderWidth: 1, borderColor: colors.line, borderRadius: 8, padding: 40, alignItems: 'center' }}>
        <Text style={{ fontFamily: font.sansSemibold, fontSize: 18, fontWeight: '600', color: colors.ink, marginBottom: 6 }}>{title}</Text>
        <Text style={{ fontFamily: font.sans, fontSize: 13, color: colors.ink3, textAlign: 'center' }}>
          This screen is wired into the shell and ready for its pixel-exact build (Phase 7) + live billing data.
        </Text>
      </View>
    </View>
  );
};

export default Placeholder;
